// extracted by mini-css-extract-plugin
export default {"submitBtn":"submit_btn_submitBtn__lTGNV","content":"submit_btn_content__CAJxi","contentLoading":"submit_btn_contentLoading__rMeum submit_btn_content__CAJxi"};